exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Palette of colours used to distinguish repeated elements */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/postcss-loader?{"ident":"postcss"}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/less-loader/dist/cjs.js?{"sourceMap":false}!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/styles/_colors.less
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../less-loader/dist/cjs.js?{"sourceMap":false}!../../../../../src/styles/_colors.less
// module chunks = 3